import { LocalDate, YearMonth, DateRange } from './types';
import { monthOf, lastDayOfMonth } from './dateHelpers';

interface ContinuationStrips {
  beforeMonth: YearMonth | null; // el rango empieza antes de la vista
  afterMonth: YearMonth | null;  // el rango termina después de la vista
}

// Se evalúa contra la vista, no contra el panel — §07. `view` es la lista
// ordenada de meses visibles: un mes en Mode=Custom (cada panel es su propia
// vista), dos en Mode=Derived (los paneles enlazados son una sola vista
// continua, así que el límite interno entre ellos nunca produce tira: solo
// miramos el primer y el último mes de la vista, nunca el punto medio).
const resolveContinuationStrips = (range: DateRange, view: YearMonth[]): ContinuationStrips => {
  const viewStart = `${view[0]}-01` as LocalDate;
  const viewEnd = lastDayOfMonth(view[view.length - 1]);
  return {
    beforeMonth: range.start < viewStart ? monthOf(range.start) : null,
    afterMonth: range.end > viewEnd ? monthOf(range.end) : null
  };
};

export { ContinuationStrips, resolveContinuationStrips };
